import './App.css'
import { useNavigate } from 'react-router-dom';
export default function InfoPage() {
  const navigate = useNavigate();
  return (
    <main className="info-page">
      <button onClick={() => navigate('/')} tabIndex={0}>
        Povratak na početni zaslon
      </button>
      <h1 tabIndex={0}>Upute za korištenje aplikacije</h1>
      <section tabIndex={0}>
        <h2>O aplikaciji</h2>
        <p>Ova aplikacija služi za učenje i vježbanje zapisa matematičkih formula u posebnom tekstualnom formatu prilagođenom slijepim i slabovidnim korisnicima.</p>
        <p>Cilj aplikacije je ovladavanje sintaksom za pisanje matematičkih formula. Svaki znak, razmak, zagrada i naredba imaju određeno značenje i potrebno ih je zapisati u ispravnom obliku i na ispravnom mjestu.</p>
        <p>
          Aplikacija je razvijena u okviru diplomskog rada na Fakultetu elektrotehnike i računarstva Sveučilišta u Zagrebu, ak. god. 2025./2026. Aplikaciju je izradila Lara Marčec pod mentorstvom prof. dr. sc. Željka Car.
        </p>
      </section>
      <section tabIndex={0}>
        <h2>Navigacija tipkovnicom u aplikaciji</h2>
        <p>Za kretanje kroz elemente koristi se tipka Tab.</p>
        <ul>
          <li>Tab pomiče fokus na sljedeći element.</li>
          <li>Shift + Tab vraća fokus na prethodni element.</li>
          <li>Razmaknica uključuje ili isključuje potvrdne okvire kod odabira kategorija na početnom zaslonu.</li>
          <li>Enter odabire gumbe.</li>
        </ul>
        <h3>Tipkovnički prečaci u zadacima</h3>
        <ul>
          <li>Strelica lijevo otvara prethodni zadatak.</li>
          <li>Strelica desno otvara sljedeći zadatak.</li>
          <li>Ctrl + Enter predaje odgovor u zadatku.</li>
        </ul>
      </section>
      <section tabIndex={0}>
        <h2>Korištenje čitača zaslona</h2>
        <p>
          Preporučuje se korisnicima čitača zaslona da uključe izgovor interpunkcije i znakova kako bi matematički izrazi bili ispravno interpretirani.
        </p>
      </section>
      <section tabIndex={0}>
        <h2>Odabir kategorija</h2>
        <p>Na početnom zaslonu potrebno je odabrati barem jednu kategoriju zadataka, a dostupan je i gumb „Odaberi sve kategorije”.</p>
        <p>Nakon odabira kategorija moguće je pokrenuti:</p>
        <ul>
          <li>Prvu razinu zadataka</li>
          <li>Drugu razinu zadataka</li>
        </ul>
      </section>
      <section tabIndex={0}>
        <h2>Prva razina zadataka</h2>
        <p>U prvoj razini potrebno je samostalno upisati formulu prema zadanom tekstualnom opisu u aplikaciji.</p>
      </section>
      <section tabIndex={0}>
        <h2>Druga razina zadataka</h2>
        <p>
          U drugoj razini potrebno je pronaći točan matematički izraz u dokumentu s formulama te ga kopirati u polje za unos.
        </p>
        <p>Dostupan je gumb „Otvori dokument s formulama”.</p>

        <h3>Dokument s formulama</h3>
        <ul>
          <li>Formule su prikazane po istim kategorijama kao i zadaci.</li>
          <li>Dokument je moguće preuzeti u PDF formatu.</li>
        </ul>
      </section>
      <section tabIndex={0}>
        <h2>Provjera odgovora</h2>
        <p>
          Nakon unosa odgovora moguće je odabrati:
        </p>
        <ul>
          <li>Provjeri uneseni odgovor</li>
          <li>Izbriši unos</li>
          <li>Prikaži rješenje</li>
        </ul>
        <p>Ako je odgovor potpuno točan, aplikacija prikazuje poruku da je odgovor točan.</p>
        <p>
          Ako je izraz gotovo točan, aplikacija prikazuje poruku: "Provjeri razmake u izrazu".<br />
          To znači da je struktura izraza dobra, ali postoji manja pogreška u formatu.
        </p>
        <p>
          Ako izraz nije točan, aplikacija prikazuje poruku da odgovor nije točan.
        </p>
      </section>
      <section tabIndex={0}>
        <h2>Prikaz izraza</h2>
        <p>Desna strana zaslona prikazuje matematički prikaz izraza samo kada je unos potpuno točan.</p>
      </section>
      <section tabIndex={0}>
        <h2>Osnovna pravila pisanja matematičkih izraza</h2>
        <ul>
          <li>
            Razmak se piše isključivo ispred osnovnih matematičkih operatora, dok se između operatora i sljedećeg broja ne piše razmak.
          </li>
          <li>
            Eksponent se piše bez razmaka uz bazu i unutar vitičastih zagrada.
          </li>
          <li>
            Razlomak se označava izrazom \raz nakon kojeg slijede brojnik i nazivnik u odvojenim vitičastim zagradama.
          </li>
          <li>
            Korijen se označava izrazom \kor nakon kojeg slijedi baza u uglatim zagradama te argument u vitičastim zagradama. 
          </li>
          <li>
            Sinus se označava izrazom \sin nakon kojeg slijedi argument u vitičastim zagradama.
          </li>
        </ul>
      </section>
      <button onClick={() => navigate('/')} tabIndex={0}>
        Povratak na početni zaslon
      </button>
    </main>
  );
}